import { Content } from '@/sharedType';

export function MessageMedia({ content }: { content: Content }) {
  if (typeof content === 'string') return null;

  let count = 0;
  content.forEach((e) => {
    if (e.type === 'file' || e.type === 'image') {
      ++count;
    }
  });

  let gridCols: string = '';
  if (count === 1) {
    gridCols = 'grid-cols-1';
  }
  if (count > 1) {
    gridCols = 'grid-cols-2';
  }
  if (count > 4) {
    gridCols = 'grid-cols-3';
  }

  if (count === 0) return null;

  return (
    <div className={`p-3 grid ${gridCols} gap-4 max-w-72`}>
      {content.map((e) => {
        if (e.type === 'file') {
          return (
            <embed key={e.data} src={e.data} type="application/pdf" className="rounded-md w-full" />
          );
        } else if (e.type === 'image') {
          return <img key={e.image} src={e.image} className="rounded-md" />;
        }
        return null;
      })}
    </div>
  );
}
